import { render, staticRenderFns } from "./OperacionesEditCliente.vue?vue&type=template&id=c94028f8&"
import script from "./OperacionesEditCliente.vue?vue&type=script&lang=js&"
export * from "./OperacionesEditCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports